/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type GetListingResponseStatus = typeof GetListingResponseStatus[keyof typeof GetListingResponseStatus];


export const GetListingResponseStatus = {
  OK: 'OK',
  RESTRICTED: 'RESTRICTED',
  USER_ACCOUNT_EXCLUSIVE: 'USER_ACCOUNT_EXCLUSIVE',
  INVALID_SECRET_ACCESS_ID: 'INVALID_SECRET_ACCESS_ID',
  INVALID_PASSWORD: 'INVALID_PASSWORD',
} as const;
